import React, { FC, useEffect, useState } from "react"

import { Space } from "antd"

import ManualSelect from "./selects/ManualSelect"
import { IAttributionItem } from "../../../../../app/types/filter"

interface IAttributionProps {
    items: IAttributionItem[]
}

const Attribution: FC<IAttributionProps> = ({ items }) => {
    const isDashboardAttributes = items.some((el)=>el.selectValues.some((element)=>element.id === "blocks") )
    return (
        <Space className="params__attr-container">
            {
                items.map((item, index) => (
                    <ManualSelect
                        key={index}
                        id={item.id}
                        name={item.name}
                        selectValues={item.selectValues}
                        description={item.description}
                        icon={item.icon}
                        isDashboardAttributes={isDashboardAttributes}
                    />
                ))
            }
        </Space>
    )
}

export default Attribution
